import { GoAButton, GoASpacer } from '@abgov/react-components';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import { useIsDesktop } from '../../utils/isDesktop';
import { useNavigate } from 'react-router-dom';
import { displaySection } from '../../common/ui-library';
import { BaseWizardProps } from '../wizard/wizard-step-base';
import { useEffect, useState } from 'react';
import { WizardButtonGroup } from '../wizard/wizard-button-group-component';
import styles from './eligibility.module.css';

interface EligibilityIntroductionProps extends BaseWizardProps {}

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

export const EligibilityIntroductionComponent = ({
  navigationConfiguration,
}: EligibilityIntroductionProps) => {
  const stateCollision = useAppSelector((state: RootState) => state.collision);
  const stateAuth = useAppSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [nextPage, setNextPage] = useState('');

  useEffect(() => {
    const pageConfig = navigationConfiguration.pagingConfiguration.find(
      (item) => item.default !== undefined,
    );
    setNextPage(pageConfig?.default ?? 'error');
  }, [navigationConfiguration]);

  return (
    <div>
      <h2 className={styles.header2}>
        See if Report My Collision is right for you
      </h2>
      <GoASpacer vSpacing={'l'} />
      <p>
        Answer the following questions to see if you meet the criteria to use
        Report My Collision
      </p>

      <WizardButtonGroup
        nextPage={nextPage}
        showViewSummaryButton={false}
        navigate={navigationConfiguration.navigate}
        buttonText={'Get started'}
        buttonTrailingIcon="arrow-forward"
      />
    </div>
  );
};
